import { render, staticRenderFns } from "./list-review-report.vue?vue&type=template&id=82fdcb48&scoped=true"
import script from "./list-review-report.vue?vue&type=script&lang=js"
export * from "./list-review-report.vue?vue&type=script&lang=js"
import style0 from "./list-review-report.vue?vue&type=style&index=0&id=82fdcb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fdcb48",
  null
  
)

export default component.exports